module.exports = __webpack_public_path__ + "img/no-profile-dark.7e046c2e.jpg";